import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import useCurrencyFormat from "@/use/useCurrencyFormat";
import {
  IPaymentInfo,
  IPaymentInfoType,
} from "@/domain/entities/payment/paymentInfo.types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentHistoryRow',
  props: {
  paymentInfo: {
    type: Object as PropType<IPaymentInfo>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const getFormattedAmount = () => {
  if (props.paymentInfo.amount === 0) return "0원";
  const payAmountCurrency = useCurrencyFormat(props.paymentInfo.amount);
  return props.paymentInfo.type === IPaymentInfoType.PAID
    ? `-${payAmountCurrency}원`
    : `+${payAmountCurrency}원`;
};

const __returned__ = { props, getFormattedAmount, get IPaymentInfoType() { return IPaymentInfoType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})